import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { DateFormats, formatDate, ssnNumberMask } from '../../utils/utils';
import Avatar, { AvatarSize, AvatarStatus } from '../Avatar';

export type customFamilyMemberCardProps = React.PropsWithoutRef<{
  className?: string;
  name: string;
  image: string;
  covers: string[] | null;
  ssn: number | null;
  dateOfBirth: number;
  relationship: string;
}>;

const FamilyMemberModalCard = ({
  className = '',
  name,
  covers,
  image,
  ssn,
  dateOfBirth,
  relationship,
}: customFamilyMemberCardProps) => {
  return (
    <Card className={`family-member-card ${className}`} bg={'transparent'}>
      <Row className={'row-wrapper'}>
        <Col xs={12} lg={4} className={'d-flex align-items-start gap-4'}>
          <Row className={'m-0'}>
            <Col className={'p-0'}>
              <Avatar
                id={name}
                size={AvatarSize.MEDIUM}
                image={image}
                name={name}
                status={AvatarStatus.ENABLED}
              />
            </Col>
            <Col xs={'auto'} className={'personal-info p-0 d-flex flex-column'}>
              <span className={'personal-info-name'}>{name}</span>
              <span>{relationship}</span>
              <span>{formatDate(new Date(dateOfBirth), DateFormats.US)}</span>
            </Col>
          </Row>
        </Col>
        <Col
          xs={12}
          lg={4}
          className={
            'd-flex align-items-center justify-content-between justify-content-lg-start'
          }
        >
          <span className={'d-flex d-lg-none text-sm-14-lg-16 fw-light'}>
            SSN
          </span>
          {ssn ? (
            <span className={'text-sm-14-lg-16'}>
              {ssnNumberMask(ssn.toString())}
            </span>
          ) : (
            <div className={'d-flex gap-3  align-items-center'}>
              <FontAwesomeIcon
                className={'text-danger'}
                icon={light('info-circle')}
              />
              <span className={'text-sm-14-lg-16'}>SSN Missing</span>
            </div>
          )}
        </Col>
        <Col
          xs={12}
          lg={4}
          className={
            'd-flex align-items-center justify-content-between justify-content-lg-end'
          }
        >
          <span className={'d-flex d-lg-none text-sm-14-lg-16 fw-light'}>
            Benefits
          </span>

          <span className={'text-sm-14-lg-16 text-primary'}>
            {covers ? covers.join(', ') : '-'}
          </span>
        </Col>
      </Row>
    </Card>
  );
};

export default FamilyMemberModalCard;
